<template>
  <div class="mobile">
    <MobileHeader/>
    <div class="main-con clearfix">
      <el-carousel height="200px">
        <el-carousel-item v-for="item in lunbtList" :key="item">
          <img :src="item.tup" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="clear"></div>
    <div class="main-con clearfix">
      <div class="block-left clearfix">
        <div class="clearfix pub-bg">
          <div class="fxl font">三色球</div>
          <div class="fxr r-font">
            <div class="fxl l">第 {{a}} 期</div>
            <div class="fxl">下期開獎時間:<br>{{b}}</div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="lotteryTime clearfix">
          <div class="leftTime clearfix">
            <div class="fxl hour">
              <span class="num-border">{{Math.floor(hours / 10) }}</span>
              <span class="num-border">{{hours % 10}}</span>
            </div>
            <span class="fxl dot dot1">:</span>
            <div class="fxl minute fxl">
              <span class="num-border">{{Math.floor(minutes / 10) }}</span>
              <span class="num-border">{{minutes % 10}}</span>
            </div>
            <span class="fxl dot dot2">:</span>
            <div class="second fxl">
              <span class="num num-border">{{Math.floor(seconds / 10) }}</span>
              <span class="num num-border">{{seconds % 10}}</span>
            </div>
          </div>
          <div class="clear h20"></div>
          <div class="btn-red fxl" style="margin: 0px 20px 0px 20px" @click="">
            直播
          </div>
          <div class="history fxr" style="padding:0px 20px;">
            <a style="color: #000" @click="jump('mobileLotteryAnnouncement')"
            >歷史開獎查詢</a
            >
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAYAAAD+WDajAAAAe0lEQVQYlW3PPQ6BURCF4efzl2gkGktQWIkIBbEMa7ID0eqUSiW1WAGNjkwyV67EaU4y7zuZTHM17GGHPbaqdLDAHLOcf4X2Rv+CJ6Yp3nEuMPr0T2hVJw54IGZrNAVOcMQgpRXeAQsYJVjiFRsBu9k/IBJ/Ro9xqwF8ANd7Gm+Pq0c7AAAAAElFTkSuQmCC"
            />
          </div>
          <div class="clear h20"></div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="main-con clearfix">
      <div class="block-list clearfix"
           v-for="(item,index) in kaijggList"
           :class="{'show':index==0||moreShow}">
        <div class="ball-out clearfix" :class="{'paddingNo':index==0}">
          <div class="fxl num" v-if="index!=0">
            第<span class="font-red">{{item.qih}}</span>期
          </div>
          <div class="clearfix" :class="{'fxl one padding20L':index==0,'fxr mini':index!=0}">
            <span class="ball small">
            <span :class="ballColor(item.kaijhm.split(',')[0])">{{item.kaijhm.split(",")[0] }}</span>
          </span>
            <span class="ball small">
            <span :class="ballColor(item.kaijhm.split(',')[1])">{{item.kaijhm.split(",")[1] }}</span>
          </span>
            <span class="ball small">
            <span :class="ballColor(item.kaijhm.split(',')[2])">{{item.kaijhm.split(",")[2] }}</span>
          </span>
            <span class="ball small">
            <span :class="ballColor(item.kaijhm.split(',')[3])">{{item.kaijhm.split(",")[3] }}</span>
          </span>
            <span class="ball small">
            <span :class="ballColor(item.kaijhm.split(',')[4])">{{item.kaijhm.split(",")[4] }}</span>
          </span>
            <span class="ball small">
            <span :class="ballColor(item.kaijhm.split(',')[5])">{{item.kaijhm.split(",")[5] }}</span>
          </span>
            <span class="ball font-red" v-if="index!=0" style="font-size: 16px; margin-left: -10px">+</span>
            <span class="ball small" :style="{margin:index==0?'-10px':'0px'}">
            <span :class="ballColor(item.kaijhm.split(',')[6])">{{item.kaijhm.split(",")[6] }}</span>
          </span>
          </div>
        </div>
        <div class="clear"></div>
        <div class="title">
          ◊◊◊◊◊獎金池金额【{{ item.jiangqgc }}】<br>◊◊◊◊◊
        </div>
        <p>♠♠♠♠一等獎:【{{ item.yidj }}】</p>
        <p>♠♠♠♠二等獎:【{{ item.erdj }}】</p>
        <p>♠♠♠♠三等獎:【{{ item.sandj }}】</p>
        <p>♠♠♠♠四等獎:【{{ item.sidj }}】</p>
        <p>♠♠♠♠五等獎:【{{ item.wudj }}】</p>
        <p>♠♠♠♠六等獎:【{{ item.liudj }}】</p>
        <p>♠♠♠♠七等獎:【{{ item.qidj }}】</p>
        <div class="clear" style="height:10px;"></div>
        <div class="last-issue clearfix" v-if="index==0" @click="more">
			    <span>查看近五期</span>
          <span class="pre" v-if="moreShow" style="margin-left:20px;"></span>
          <span class="next" v-if="!moreShow" style="margin-left:20px;"></span>
        </div>
      </div>
    </div>
    <MobileFooter :tab-select="tabSelect"/>
  </div>
</template>

<script>
import MobileHeader from "./MobileHeader";
import MobileFooter from "./MobileFooter";
import axios from "axios";

export default {
  components: {
    MobileHeader,
    MobileFooter,
  },
  computed: {
    ballColor(num) {

      return function (num) {
        const red = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];
        const green = [5, 6, 11 , 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];
        const blue = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];
        
        if(red.includes(parseInt(num)))
          return "balls red"
        if(green.includes(parseInt(num)))
          return "balls green"
        if(blue.includes(parseInt(num)))
          return "balls blue"
        
      }
    },
  },

  data() {
    return {
      moreShow:false,
      a: null,
      b: null,
      zuixyq: [],
      interval: null,
      targetDate: null,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,

      qih: "",
      kaijhm: [],
      kaijggList: [],
      lunbtList: [],
      listData: [
        { name: "一等獎", num: "$10,000,000" },
        { name: "二等獎", num: "$5,000,000" },
        { name: "三等獎", num: "$30,000" },
        { name: "四等獎", num: "$1,000" },
        { name: "五等獎", num: "$200" },
        { name: "六等獎", num: "$100" },
        { name: "七等獎", num: "$10" },
      ],
      tabSelect: 0,
    };
  },

  // 注入全局变量
  inject: ["imageUrl", "serviceUrl"],
  beforeUnmount() {
    // 清除定时器，防止内存泄漏
    clearInterval(this.interval);
  },

  mounted() {
    let that = this;

    axios
      .get(that.serviceUrl + "/sys/api/queryDictItemsByCode", {
        params: { code: "zuixyq" },
      })
      .then((resp) => {
        that.zuixyq = resp.data;
        let tmp = that.zuixyq[1].value
        tmp = tmp.replace(' ', 'T');
        that.targetDate = new Date(tmp + "+08:00")

        that.calculateTime();
        // 每秒更新一次倒计时
        that.interval = setInterval(() => {
          that.calculateTime();
        }, 1000);
        
        that.a = that.zuixyq[0].value
        that.b = that.zuixyq[1].value
        
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(that.serviceUrl + "/lunbt/ayLunbt/list", {
        params: {},
      })
      .then((resp) => {
        console.log(resp);
        resp.data.result.records.forEach((element) => {
          element.tup = that.imageUrl + element.tup;
        });

        that.lunbtList = resp.data.result.records;
      })
      .catch((error) => {
        console.log(error);
      });

    this.loadData()
  },

  methods: {
    loadData() {
      let that = this

      axios
      .get(that.serviceUrl + "/kaijgg/ayKaijgg/list", {
        params: {
          shifxs: "1",
          column: "qih",
          order: "desc",
          pageNo: 1,
          pageSize: 5,
        },
      })
      .then((resp) => {
        that.kaijggList = resp.data.result.records;
        that.kaijhm = resp.data.result.records[0].kaijhm.split(",");
        that.qih = resp.data.result.records[0].qih;
      })
      .catch((error) => {
        console.log(error);
      });
    },

    kaij() {
      let that = this

      axios
      .put(that.serviceUrl + "/kaijgg/ayKaijgg/kaij", {
        params: {
        },
      })
      .then((resp) => {
        that.loadData()
      })
      .catch((error) => {
        console.log(error);
      });
    },

    more(){
      this.moreShow = !this.moreShow
    },

    calculateTime() {
      const now = new Date();
      const difference = this.targetDate - now;

      // Calculate total hours remaining
      const totalHours = Math.floor(difference / (1000 * 60 * 60));

      // Calculate days, hours, minutes, and seconds
      this.hours = totalHours;
      this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((difference % (1000 * 60)) / 1000);

      // If the target date has passed, stop the countdown and set values to "00"
      if (difference <= 0) {
        clearInterval(this.interval);

        this.hours = "00";
        this.minutes = "00";
        this.seconds = "00";

        this.kaij()
      }
    },

    jump(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="less">
.block-list{
  display: none;
  font-size:16px;
  .title{
    font-size:16px;
    padding:10px 20px;
  }
  p{
    padding:0px 20px;
  }
}
.block-left {
  border: 1px solid #dadada;
  border-radius: 4px;
  background-color: #fff;

  .con {
    .l-con {
      padding: 40px 0px 0px 20px;

      .title {
        line-height: 50px;
        padding: 0px 0px 20px 0px;
      }
    }

    .r-con {
    }
  }
}

.pub-bg {
  background-color: #ffc9c9;
  border: 1px solid #d80011;
  color: #d80011;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  font-size: 14px;

  .r-font{
    display: flex;
    line-height:20px;
    justify-content: center;
    align-items: center;
    .l{
      color:#000;
      height:100%;
      padding:0px 5px 0px 0px;
      margin:0px 5px 0px 0px;
      border-right:2px solid #d80011;
    }

  }
}

.block-right {

  .name {
    width: 80px;
    display: inline-block;
  }
}

:deep(.el-carousel img) {
  width: 100% !important;
  height:100%;
}

:deep(.el-table .cell) {
  line-height: 40px;
}

:deep(.el-table tr),
:deep(.el-table th.el-table__cell) {
  color: #fed001;
  background: #4c5880;
  border: 0px;
}

:deep(.el-table td.el-table__cell),
:deep(.el-table th.el-table__cell.is-leaf) {
  border: 0px;
}

:deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
  background-color: rgba(140, 182, 222, 0.1);
}

.border-top {
  border-top: 5px solid #212c4f;
}

.table {
  text-align: center;
  color: #fed001;
  background: #4c5880;
  border-bottom: 3px solid #eee222;

  h1 {
    width: 100%;
    font-size: 20px;
    text-align: left;
    padding: 8px 0px 5px 0px;
    font-weight: normal;
    border-bottom: 1px solid #2b3d61;
    background-image: linear-gradient(#374779, #2b3659);

    span {
      padding: 0px 20px;
    }
  }
}

.lotteryTime {
}

.lotteryTime .nextTime {
  width: 320px;
  height: 45px;
  line-height: 45px;
  color: #e6541a;
  font-size: 14px;
  padding-left: 40px;
}

.lotteryTime .leftTime {
  position: relative;
  margin: 20px 0px 0px 20px;
}

.lotteryTime .check {
  height: 40px;
  width: 390px;
  clear: both;
  padding-left: 50px;
  position: relative;
  top: 30px;
}

.lotteryTime .check .suf {
  width: 306px;
  height: 130px;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: 306px 144px;
  background-position: -4px -8px;
  position: absolute;
  top: 40px;
  left: 25px;
  z-index: 1;
  color: #525252;
}

.lotteryTime .check .suf .title {
  height: 30px;
  line-height: 30px;
  width: 200px;
  font-size: 15px;
  color: #d80011;
  position: relative;
  top: 16px;
  left: 6px;
}

.lotteryTime .check .suf .title .title-text {
  display: inline-block;
  margin-left: 40px;
}

.lotteryTime .check .suf .title img {
  position: absolute;
  left: 10px;
  top: 6px;
}

.lotteryTime .check .suf p {
  width: 270px;
  margin: 0 auto;
  font-size: 12px;
  line-height: 24px;
  word-break: break-all;
  padding: 0 8 0 0;
}

.lotteryTime .check .suf p span {
  color: #d80011;
}

.lotteryTime .check .suf p:first-of-type {
  margin-top: 16px;
}

.lotteryTime .check .button {
  height: 34px;
  line-height: 34px;
  width: 100px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  float: left;
  cursor: pointer;
  outline: none;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAiCAYAAACp43wlAAACeElEQVRoge2bP2/TUBTFz315duKEoJKBpSiKKBURAxML36QDHRg6tBLqtyELgqEL36QCFYYWQRD/qgomUKloExn/Re9h105ozeQXK7k/6cWSPTzrHJ179a5iit9t4Nnj530AmwAeAOiAMclPADsABg+31ob09FH7thBieO/+XfRWlmHbEnEcsSMGIBLwvRBfPn3F3u4+oijqSZUMZcZqvwvv9wijUxdhGADx3OsxWwio1SSk5WjtwyDEqxcHm8qQ9d6tZW3G2a/vcEcn8H0XiNmRUiGCZTXgtJZAV69jpd9VhmwoQzq2JTFyXbjjE4xOf8DzxmxI2RDBtps6KXWnjVajpTbsKEN0z4jCAIHvwvfG8N2zeZaiMhCgNVfap31b5l+OEP9dtMgymSPVO8+5IakJ6sqGmCGvecpkQogNMclFWmtD0nvTV6Z8pjXPSlbywwkxh9aZJgOQlazkARtiDqIsCCncQ2bIpT0EOacIbIgp8pqnKZlIiMgtpnxSvfPwOWSG8DmkYlzeQxLYELMUHgwpd0JhQwyRbxPJjlPDxWwx5UP4V2suWTOksIfw6MQ8xaMTLlnGKS5ZPMsyTuEsi0uWeS4qWTwlqRjnw0XkIsQJMcP0+Q/c1GfLf5u6tksQO2IKQZPH9Gx0IiCERE02IK2mfh7zH+VKhYhQs5pac6U9Je1cGXLs+UFHPbDqS/pmFLhsSMkoQ0SieU068PxAbXisDNn5/OHbdv9OF/UWIOttxFEwz1pUBtJVydFJeX9wqF7riTJksLe7v63K1M3VG7CdKyoji66VIQR8P8THt0d4/fKN2nIw/cHOOoBriyBFhcg+2NlaG/4BQIibYt2d6+0AAAAASUVORK5CYII=);
  background-repeat: no-repeat;
}

.lotteryTime .history {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #3f3f3f;
}

.lotteryTime .history:hover {
  color: #d80011;
}

.lotteryTime .history img {
  position: relative;
  top: 0;
}
.last-issue {
  width: calc(100% - 0px);
  padding:10px 0px;
  font-size: 16px;
  border: 1px solid #c3c3c3;
  border-left: none;
  border-right: none;
  border-radius: 0 0 .5px 5px;
  color: #d80011;
  text-align: center;
}

.last-issue .icon {
  font-size: 16px;
  color: #d80011;
  font-weight: 700;
  margin-left: 10px;
  -webkit-transition: all .618s;
  transition: all .618s;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg)
}

.last-issue .icon.rotate {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg)
}
.ball-out{
  padding:0px 5px;
  background:#f4f4f4;
  .one{
    width:calc(100% - 5px);
    padding:10px 0px 0px 0px;
    background:#fff;
  }
  .num{
    font-size:14px;
    padding:15px 0px 0px 0px;
  }
  .ball{
    &.small{
      margin-left:-8px;
    }
  }
}
.show{
  display: block;
}
</style>
